export const scrollToElement = (
  itemId: string,
  delay: number = 300,
  scrollFn?: (id: string) => void,
): void => {
  setTimeout(() => {
    if (scrollFn) {
      scrollFn(itemId);
      return;
    }
    const element = document.getElementById(itemId);
    if (!element) {
      return;
    }
    if (typeof element.scrollIntoView === 'function') {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  }, delay);
};
